import React, { Component } from "react";
import styled from "styled-components";
import { ButtonText, ICONS } from "@loanbossinc/component-library";
import { Collapse } from "@material-ui/core";
import { PeopleGuestDataTable } from "./peopleGuestDataTable";
import pluralize from 'pluralize';
import { StyledFooterText, StyledModuleFooter } from "component-lib/ModuleFooter";

const SELECTION_LABELS = {
  ADD_A_GUEST: "Add a guest to this deal"
  , NO_GUESTS: "No guests"
  , GUEST_ACCESS_AMOUNT: "guests can access this deal"
}
export class PeopleGuest extends Component {
  state = {
    isExpanded: false
    , iconName: ICONS.UNFOLD_MORE
  }

  toggleIsExpanded = () => {
    this.renderTable();
    this.setState({
      isExpanded: !this.state.isExpanded,
      iconName: !this.state.isExpanded ? ICONS.UNFOLD_LESS : ICONS.UNFOLD_MORE
    });
  }

  renderTable = () => {
    const { guestList, onDeleteGuest, deal } = this.props;
    const { isExpanded } = this.state;

    return (
      <Collapse in={isExpanded}>
        <PeopleGuestDataTable
          guestList={guestList}
          onDeleteGuest={onDeleteGuest}
          deal={deal} />
      </Collapse>
    )
  }

  getRightButton = () => {
    const { guestList } = this.props;
    const { isExpanded, iconName } = this.state;

    if (!guestList || !guestList.length) return <StyledFooterText className="align-right">No Guests</StyledFooterText>;

    let label = 'Show less';
    if (!isExpanded) label = pluralize('Guest', guestList.length, true);

    return (
      <ButtonText
        alignRight
        onClick={this.toggleIsExpanded}
        label={label}
        iconName={iconName}
      />
    )
  }

  renderFooterButton = () => {
    return (
      <StyledModuleFooter>
        <ButtonText onClick={this.props.onAddGuest} label={SELECTION_LABELS.ADD_A_GUEST} />
        {this.getRightButton()}
      </StyledModuleFooter>
    );
  }

  render() {
    const { authentication } = this.props;
    if (authentication.isGuest) return null;
    return (
      <>
        {this.renderTable()}
        {this.renderFooterButton()}
      </>
    )
  }
}